import { Capacitor, registerPlugin } from '@capacitor/core';

const deviceSettings = registerPlugin('WiwDeviceSettings');

// iOS uses a localized UIAlertController. Older shells and the website keep a
// real system/browser confirmation; a missing or failed dialog never approves.
export async function confirmSystemAction(options) {
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios' &&
      Capacitor.isPluginAvailable('WiwDeviceSettings')) {
    try {
      const result = await deviceSettings.confirmAction(options);
      return result?.confirmed === true;
    } catch (error) {
      if (error?.code !== 'UNIMPLEMENTED') throw error;
    }
  }
  return window.confirm(`${options.title}\n\n${options.message}`) === true;
}
